var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStbe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFF",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -30.625 89.25 89.375",
    transform: "matrix(.69 0 0 .69 15.5 15.5)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.682 13.292h-5.224v18.886H8.204V8.612a3.153 3.153 0 0 0-6.308 0v48.101h6.309V41.555h73.056v15.158h6.309V41.555 29.909c-.003-12.617-33.662-16.617-51.888-16.617z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.384,
    cy: 21.103,
    r: 9.112
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.251 1.478a15.118 15.118 0 0 0 5.793 1.151c8.387.001 15.183-6.797 15.183-15.183 0-8.384-6.796-15.184-15.183-15.185-2.052 0-4.006.414-5.793 1.15 5.509 2.278 9.392 7.7 9.392 14.034 0 6.334-3.883 11.757-9.392 14.033zM31.255-26.625l1.148 2.325 2.566.374-1.856 1.809.437 2.556-2.295-1.207-2.295 1.207.438-2.556-1.856-1.809 2.565-.374zM17.733-10.128l1.148 2.325 2.567.374-1.857 1.809.438 2.556-2.296-1.207-2.295 1.207.438-2.556-1.856-1.809 2.566-.374zM51.134-23.561l1.148 2.325 2.567.373-1.857 1.81.438 2.556-2.296-1.207-2.295 1.207.438-2.556-1.857-1.81 2.567-.373z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStbe);
export default __webpack_public_path__ + "static/media/STBE.e3ad596c37e307702a7baf061dce1d4e.svg";
export { ForwardRef as ReactComponent };